"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputAutocompleteGroupAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputAutocompleteGroup = require("../InputAutocompleteGroup");

var _FormikAdapter = require("./FormikAdapter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* play nice with redux-form but can be overridden with customOptions */
var InputAutocompleteGroupAdapter = function InputAutocompleteGroupAdapter(_ref) {
  var field = _ref.field,
      form = _ref.form,
      atts = _ref.atts,
      label = _ref.label,
      cashbotName = _ref.cashbotName,
      isRequiredField = _ref.isRequiredField,
      choices = _ref.choices,
      customOptions = _ref.customOptions;
  // Set Custom Option overrides
  var handleBlur = customOptions.onBlur || field.onBlur;
  var handleFocus = customOptions.onFocus || null;
  var handleChange = customOptions.onChange || field.onChange;
  var handleSelect = customOptions.onSelect || field.onChange; // specifically check for undefined as we want to allow value to be an empty string

  var value = typeof customOptions.value !== 'undefined' ? customOptions.value : field.value;
  return _react.default.createElement(_FormikAdapter.FormikAdapter, {
    field: field,
    form: form,
    options: {
      atts: atts
    },
    render: function render(props) {
      return _react.default.createElement(_InputAutocompleteGroup.InputAutocompleteGroup, _extends({}, props, {
        value: value,
        label: label,
        cashbotName: cashbotName,
        isRequiredField: isRequiredField,
        choices: choices,
        wrapperProps: customOptions.wrapperProps,
        renderItem: customOptions.renderItem,
        getItemValue: customOptions.getItemValue,
        shouldItemRender: customOptions.shouldItemRender,
        sortItems: customOptions.sortItems,
        onChange: handleChange,
        onSelect: handleSelect,
        onFocus: handleFocus,
        onBlur: handleBlur
      }));
    }
  });
};

exports.InputAutocompleteGroupAdapter = InputAutocompleteGroupAdapter;
InputAutocompleteGroupAdapter.defaultProps = {
  atts: {
    type: 'text'
  },
  isRequiredField: true,
  customOptions: {}
};
InputAutocompleteGroupAdapter.propTypes = {
  atts: _propTypes.default.shape({
    type: _propTypes.default.oneOf(['email', 'tel', 'text'])
  }),
  field: _propTypes.default.object.isRequired,
  form: _propTypes.default.object.isRequired,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  isRequiredField: _propTypes.default.bool,
  choices: _propTypes.default.array.isRequired,
  customOptions: _propTypes.default.shape({
    value: _propTypes.default.string,
    wrapperProps: _propTypes.default.object,
    renderItem: _propTypes.default.func,
    getItemValue: _propTypes.default.func,
    shouldItemRender: _propTypes.default.func,
    sortItems: _propTypes.default.func,
    onChange: _propTypes.default.func,
    onSelect: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func
  })
};